import { render, staticRenderFns } from "./facet-collapse-icon.vue?vue&type=template&id=0d6f361e"
import script from "./facet-collapse-icon.vue?vue&type=script&lang=js"
export * from "./facet-collapse-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports